jQuery(($) => {
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Browser - Keydown Focus Class
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $("body").on("keydown", function () {
    if (!$(".keyboard-in-use")[0]) {
      $(this).addClass("keyboard-in-use");
    }
  });

  $("body").on("mousedown", function () {
    if ($(".keyboard-in-use")[0]) {
      $(this).removeClass("keyboard-in-use");
    }
  });



    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Header On Scroll
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    var lastScrollTop = 0;

    $(window).on("scroll load", function () {
      if ($(".o-header--sticky")[0]) {
        var windowTop = $(this).scrollTop();

        if (windowTop < lastScrollTop) {
          $(".o-header").addClass("o-header--scroll-up");
        } else {
          $(".o-header").removeClass("o-header--scroll-up");
        }

        lastScrollTop = windowTop;

        if (windowTop > 10) {
          $(".o-header").addClass("o-header--scroll");
        } else {
          $(".o-header").removeClass("o-header--scroll");
          $(".o-header").removeClass("o-header--scroll-up");
        }
      }
    });
});
